import request from "@/utils/request";

const api = {
  Home: "/workbench/home",
  AppList: "/workbench/appList",
  AddCommonApp: "/workbench/addCommonApp",
  DeleteCommonApp: "/workbench/deleteCommonApp",
  AddHideApp: "/workbench/addHideApp",
  DeleteHideApp: "/workbench/deleteHideApp",

};

export function getWorkbenchHome(parameter) {
  return request({
    url: api.Home,
    method: "get",
    params: parameter,
  });
}

export function getAppList(parameter) {
  return request({
    url: api.AppList,
    method: "get",
    params: parameter,
  });
}

export function addCommonApp(parameter) {
  return request({
    url: api.AddCommonApp,
    method: "post",
    params: parameter,
  });
}

export function deleteCommonApp(parameter) {
  return request({
    url: api.DeleteCommonApp,
    method: "post",
    params: parameter,
  });
}

export function addHideApp(parameter) {
  return request({
    url: api.AddHideApp,
    method: "post",
    params: parameter,
  });
}

export function deleteHideApp(parameter) {
  return request({
    url: api.DeleteHideApp,
    method: "post",
    params: parameter,
  });
}
